import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=2632fd2a&"
import script from "./VSpinner.vue?vue&type=script&lang=ts&"
export * from "./VSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports